.button {
    gap: 6px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
}

.play-icon {
    display: flex;
    flex-shrink: 0;
    transform-origin: center;
    transition: transform 160ms ease;
}

.play-icon :global(svg) {
    color: var(--orange) !important;
    fill: var(--orange) !important;
    transition:
        color 160ms ease,
        fill 160ms ease;
}

.button:hover .play-icon,
.button:focus-visible .play-icon {
    transform: scale(1.2);
}

.button:hover .play-icon :global(svg),
.button:focus-visible .play-icon :global(svg) {
    color: var(--orange) !important;
    fill: var(--orange) !important;
}
